module.exports = __webpack_public_path__ + "static/media/tip_dog_tick_en.c3366782.png";